import React from 'react';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

function ExternalLinkIcon() {
  return (
    <>
      <OpenInNewIcon className='ml-1.5' style={{ fontSize: '0.8em' }} />
      <span className='sr-only'>(Opens in a new window)</span>
    </>
  );
}

export default ExternalLinkIcon;
